import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { DashboardLayout } from '@/layout/DashboardLayout';
import { Dashboard } from '@/pages/Dashboard';
import { ProductList } from '@/pages/products/ProductList';
import { ProductForm } from '@/pages/products/ProductForm';
import { OrderList } from '@/pages/orders/OrderList';
import { OrderDetail } from '@/pages/orders/OrderDetail';
import { Analytics } from '@/pages/Analytics';
import { Finance } from '@/pages/Finance';
import { Reviews } from '@/pages/Reviews';
import { Settings } from '@/pages/Settings';
import { Store } from '@/pages/Store';
import { BankAccounts } from '@/pages/BankAccounts';
import { Login } from '@/pages/Login';
import { PendingApproval } from '@/pages/PendingApproval';
import { ProtectedRoute } from '@/components/shared/ProtectedRoute';
import { RequireApproved } from '@/components/shared/RequireApproved';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<Login />} />

        {/* Authenticated, but no dashboard chrome — shown until the store is
            verified so a new/rejected vendor always has context + a clear next
            step instead of an empty, broken dashboard. */}
        <Route
          path="/pending"
          element={
            <ProtectedRoute>
              <PendingApproval />
            </ProtectedRoute>
          }
        />

        {/* Protected vendor routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          {/* Verified-only group — unverified vendors are redirected to
              /pending by the parent gate, so no per-route wrapper to forget. */}
          <Route element={<RequireApproved />}>
            <Route index element={<Dashboard />} />
            <Route path="products" element={<ProductList />} />
            <Route path="products/new" element={<ProductForm />} />
            <Route path="products/:id" element={<ProductForm />} />
            <Route path="orders" element={<OrderList />} />
            <Route path="orders/:id" element={<OrderDetail />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="finance" element={<Finance />} />
            <Route path="finance/bank-accounts" element={<BankAccounts />} />
            <Route path="reviews" element={<Reviews />} />
          </Route>

          {/* Always open so a pending/rejected vendor can fix KYC + account. */}
          <Route path="store" element={<Store />} />
          <Route path="settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
